/**
 * Pending save menu intent: persisted across auth redirect so we can resume save
 * after login. Stored in sessionStorage (same tab, survives Auth0 redirect).
 */

import { ROUTES } from './routes-helper'
import { PENDING_SAVE_MENU_INTENT_KEY } from './static-constants'
import type { MenuScanDish } from '../api/menuScanApi'

export interface PendingSaveMenuIntent {
  scanId: string
  dishes: MenuScanDish[]
  restaurantId?: string | null
  returnRoute: string
}

export function getPendingSaveMenuIntent(): PendingSaveMenuIntent | null {
  try {
    const raw = sessionStorage.getItem(PENDING_SAVE_MENU_INTENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingSaveMenuIntent
    if (!parsed?.scanId || !Array.isArray(parsed.dishes)) return null
    return {
      ...parsed,
      returnRoute: parsed.returnRoute ?? ROUTES.MENU_SCAN_RESULTS,
    }
  } catch {
    return null
  }
}

export function setPendingSaveMenuIntent(intent: PendingSaveMenuIntent): void {
  try {
    sessionStorage.setItem(PENDING_SAVE_MENU_INTENT_KEY, JSON.stringify(intent))
  } catch {
    // ignore
  }
}

export function clearPendingSaveMenuIntent(): void {
  try {
    sessionStorage.removeItem(PENDING_SAVE_MENU_INTENT_KEY)
  } catch {
    // ignore
  }
}
